import { action } from "mobx";
import NestStore from "~/stores/NestStore";
import Immersive3dTourFloorPlanUpdateRequestRepository from "~/repository/Immersive3dTour/Immersive3dTourFloorPlanUpdateRequestRepository";

class Immersive3dTourFloorPlanUpdateRequestStore extends NestStore {
  tourId = null;

  immersive3dTourFloorPlanUpdateRequestRepository = null;

  constructor() {
    super();

    this.immersive3dTourFloorPlanUpdateRequestRepository = new Immersive3dTourFloorPlanUpdateRequestRepository();
  }

  @action
  update() {
    this.isLoading = true;

    return this.immersive3dTourFloorPlanUpdateRequestRepository
      .update(this.tourId)
      .catch(error => {
        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default Immersive3dTourFloorPlanUpdateRequestStore;
